/**
 * EmptyState — eDMS Design System (UX bolder-refresh).
 * Teaches instead of apologising (UX_REFRESH_DIRECTION.md §5): an icon, a title,
 * guidance copy, and an optional CTA. Token-driven, dark-mode + RTL safe.
 */
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './EmptyState.module.css';

export interface EmptyStateProps {
  /** Leading glyph/illustration (emoji or element). */
  icon?: ReactNode;
  title: string;
  /** Guidance copy — what this is + how to populate it. */
  description?: ReactNode;
  /** Optional call-to-action (button/link). */
  action?: ReactNode;
  /** Compact variant for inline/panel empties. */
  compact?: boolean;
  className?: string;
}

export function EmptyState({ icon, title, description, action, compact = false, className }: EmptyStateProps) {
  return (
    <div className={clsx(styles.empty, compact && styles.compact, className)} role="status">
      {icon != null && <div className={styles.icon} aria-hidden="true">{icon}</div>}
      <p className={styles.title}>{title}</p>
      {description != null && <p className={styles.description}>{description}</p>}
      {action != null && <div className={styles.action}>{action}</div>}
    </div>
  );
}
